module.exports = __webpack_public_path__ + "static/media/wordpress-ai.c45bb204.png";